const React = require('react');
const { default: Styled, createGlobalStyle } = require('styled-components');
const T = require('prop-types');

const { default: clsx } = require('clsx');
const { default: TextField } = require('@mui/material/TextField');
const ActiveFilterSearchBar = require('components/ActiveFilterSearchBar');
const BottomButtonContainer = require('components/BottomButtonContainer');
const NotifyUsersFilterDialog = require('containers/NotifyUsersFilterDialog');
const useForm = require('hooks/useForm');
const BatchNotifyFormConfig = require('./formConfig');
const NerpyOutreachAdmin = require('components/Nerpy/OutreachAdmin');
const NerpyTriviaAdmin = require('components/Nerpy/TriviaAdmin');

const { default: Classes } = require('./styles.scss');
const { default: InputLabel } = require('@mui/material/InputLabel');
const { default: Typography } = require('@mui/material/Typography');
const _capitalize = require('lodash/capitalize');
const { useTheme } = require('@mui/material/styles');
const { default: useMediaQuery } = require('@mui/material/useMediaQuery');
const { default: Paper } = require('@mui/material/Paper');
const { default: Chip } = require('@mui/material/Chip');
const { default: Button } = require('@mui/material/Button');
const { default: Avatar } = require('@mui/material/Avatar');
const { default: Autocomplete } = require('@mui/material/Autocomplete');
const { default: ListSubheader } = require('@mui/material/ListSubheader');
const { default: Dialog } = require('@mui/material/Dialog');
const { default: DialogTitle } = require('@mui/material/DialogTitle');
const { default: DialogContent } = require('@mui/material/DialogContent');
const { default: DialogContentText } = require('@mui/material/DialogContentText');
const { default: DialogActions } = require('@mui/material/DialogActions');

const { VariableSizeList } = require('react-window');
const Copy = require('clipboard-copy');

const { default: ExpandLess } = require('@mui/icons-material/ExpandLess');
const { default: ExpandMore } = require('@mui/icons-material/ExpandMore');
const { default: Collapse } = require('@mui/material/Collapse');
const Dayjs = require('dayjs');
const timezone = require('dayjs/plugin/timezone');
const utc = require('dayjs/plugin/utc');

Dayjs.extend(utc);
Dayjs.extend(timezone);

const { EditorState, Modifier, ContentState, convertFromHTML } = require('draft-js');
const { Editor } = require('react-draft-wysiwyg');

//DRAFT-JS EDITOR STYLES
require('react-draft-wysiwyg/dist/react-draft-wysiwyg.css');
const { stateToHTML } = require('draft-js-export-html');

const { useEffect, useMemo, useRef, useState } = React;

const MB_IN_BYTES = 1000000;
const NOTIFICATION_BLAST_LIMIT = 1600;

const internals = {};

internals.asArray = (value) => Array.isArray(value) ? value : [];
internals.getUserOptionLabel = (option = {}) => `${option.firstName?.toString() || ''} ${option.lastName?.toString() || ''}`.trim();
internals.getUserSearchText = (option = {}) => [
    internals.getUserOptionLabel(option),
    option.email || ''
].join(' ').trim().toLowerCase();
internals.filterUserOptions = (options = [], state = {}) => {

    const query = String(state.inputValue || '').trim().toLowerCase();

    if (!query) {
        return options;
    }

    return options.filter((option) => internals.getUserSearchText(option).includes(query));
};

const StyledChip = Styled(Chip)`
    && {
        height: 40px;
        padding: 5px;

        &:focus {
            outline: auto 2px -webkit-focus-ring-color;
        }
    }

    .MuiChip-avatar {
        height: 36px !important;
        width: 36px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        object-fit: contain;

        & svg {
            width: 100%;
            height: auto;
        }
    }
`;

const LinkToolbarComponent = ({
    expanded,
    doCollapse,
    onExpandEvent,
    config,
    onChange,
    currentState,
    translations
}) => {

    const [showModal, setShowModal] = useState(true);
    const [linkTarget, setLinkTarget] = useState('');
    const [linkTargetError, setLinkTargetError] = useState(false);
    const [linkTitle, setLinkTitle] = useState('');
    const [linkTargetOption, setLinkTargetOption] = useState(
        config.defaultTargetOption
    );

    const theme = useTheme();
    useEffect(() => {

        if (!expanded) {
            setShowModal(false);
            setLinkTarget('');
            setLinkTitle('');
            setLinkTargetOption(config.defaultTargetOption);
        }
    }, [expanded, config]);

    const removeLink = () => {

        if (currentState.link) {
            onChange('unlink');
        }
    };

    const addLink = () => {

        onChange('link', linkTitle, linkTarget, linkTargetOption);
    };

    const isHttpValid = (str) => {

        const urlRegex = /^(?:(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?(?:\/[^\s]*)?)?$/;
        return urlRegex.test(str);

    };

    const updateValue = (event) => {

        const { name, value } = event.target;
        if (name === 'linkTitle') {
            setLinkTitle(value);
        }
        else if (name === 'linkTarget') {

            setLinkTarget(value);

            if (isHttpValid(value)) {
                setLinkTargetError(false);
            }
            else {
                setLinkTargetError(true);
            }
        }
    };

    const signalExpandShowModal = () => {

        const { link, selectionText } = currentState;
        const currentLinkTarget = (link && link.target) || '';
        const currentLinkTargetOption = (link && link.targetOption) || linkTargetOption;
        const currentLinkTitle = (link && link.title) || selectionText;

        onExpandEvent();
        setShowModal(true);
        setLinkTarget(currentLinkTarget);
        setLinkTargetOption(currentLinkTargetOption);
        setLinkTitle(currentLinkTitle);
    };

    const renderAddLinkModal = () => {

        return (
            <div
                className={'rdw-link-modal'}
                onClick={(event) => event.stopPropagation()}
            >
                <label className="rdw-link-modal-label" htmlFor="linkTitle">
                    {translations['components.controls.link.linkTitle']}
                </label>
                <input
                    id="linkTitle"
                    className="rdw-link-modal-input"
                    onChange={updateValue}
                    onBlur={updateValue}
                    name="linkTitle"
                    value={linkTitle}
                />
                <label className="rdw-link-modal-label" htmlFor="linkTarget">
                    {translations['components.controls.link.linkTarget']}
                </label>
                <input
                    id="linkTarget"
                    className="rdw-link-modal-input"
                    onChange={updateValue}
                    onBlur={updateValue}
                    name="linkTarget"
                    value={linkTarget}
                />
                {linkTargetError && <span style={{ color: theme.palette.error.main }}>Enter valid URL</span>}
                <span className="rdw-link-modal-buttonsection">
                    <button
                        className="rdw-link-modal-btn"
                        onClick={addLink}
                        disabled={!linkTarget || !linkTitle || linkTargetError}
                    >
                        {translations['generic.add']}
                    </button>
                    <button className="rdw-link-modal-btn" onClick={doCollapse}>
                        {translations['generic.cancel']}
                    </button>
                </span>
            </div>
        );
    };

    const renderInFlatList = () => {

        const { options, link, unlink } = config;

        return (
            <div className={'rdw-link-wrapper'} aria-label="rdw-link-control">
                {options.indexOf('link') >= 0 && (
                    <div
                        value="unordered-list-item"
                        className={clsx(link.className, 'rdw-option-wrapper')}
                        onClick={signalExpandShowModal}
                        aria-haspopup="true"
                        aria-expanded={showModal}
                        title={link.title || translations['components.controls.link.link']}
                    >
                        <img src={link.icon} alt="" />
                    </div>
                )}
                {options.indexOf('unlink') >= 0 && (
                    <div
                        disabled={!currentState.link}
                        className={clsx(unlink.className, 'rdw-option-wrapper', !currentState.link && 'rdw-option-disabled')}
                        onClick={removeLink}
                        title={
                            unlink.title || translations['components.controls.link.unlink']
                        }
                    >
                        <img src={unlink.icon} alt="" />
                    </div>
                )}
                {expanded && showModal ? renderAddLinkModal() : undefined}
            </div>
        );
    };

    const renderInDropDown = () => {

        const { title } = config;
        return (
            <div className="rdw-link-wrapper" aria-haspopup="true" aria-label="rdw-link-control" aria-expanded={expanded} title={title}>
                {/* ... rest of the content */}
            </div>
        );
    };

    return config.inDropdown ? renderInDropDown() : renderInFlatList();
};

LinkToolbarComponent.propTypes = {
    expanded: T.bool,
    doCollapse: T.func,
    onExpandEvent: T.func,
    config: T.object,
    onChange: T.func,
    currentState: T.object,
    translations: T.object
};

const UserChip = (props) => {

    const {
        user
    } = props;

    const imgUrl = user?.croppedPicture || null;

    return (
        <StyledChip
            avatar={imgUrl && <Avatar alt={`${user.firstName} img`} src={imgUrl} srcSet={imgUrl} />}
            label={`${user.firstName} ${user.lastName}`}
            {...props}
            tabIndex={0}
            aria-label={`User ${user.firstName} ${user.lastName}`}
        />
    );
};

UserChip.propTypes = {
    user: T.object
};

const LISTBOX_PADDING = 8; // px

const renderRow = (props) => {

    const { data, index, style } = props;
    return React.cloneElement(data[index], {
        style: {
            ...style,
            top: style.top + LISTBOX_PADDING
        }
    });
};

const OuterElementContext = React.createContext({});

// eslint-disable-next-line react/display-name
const OuterElementType = React.forwardRef((props, ref) => {

    const outerProps = React.useContext(OuterElementContext);
    return <div ref={ref} {...props} {...outerProps} />;
});

const useResetCache = (data) => {

    const ref = React.useRef(null);
    React.useEffect(() => {

        if (ref.current !== null) {
            ref.current.resetAfterIndex(0, true);
        }
    }, [data]);
    return ref;
};

// Adapter for react-window
// eslint-disable-next-line react/display-name
const ListboxComponent = React.forwardRef((props, ref) => {

    const { children, ...other } = props;
    const itemData = React.Children.toArray(children);
    const theme = useTheme();
    const smUp = useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
    const itemCount = itemData.length;
    const itemSize = smUp ? 36 : 48;

    const getChildSize = (child) => {

        if (React.isValidElement(child) && child.type === ListSubheader) {
            return 48;
        }

        return itemSize;
    };

    const getHeight = () => {

        if (itemCount > 8) {
            return 8 * itemSize;
        }

        return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
    };

    const gridRef = useResetCache(itemCount);

    return (
        <div ref={ref}>
            <OuterElementContext.Provider value={other}>
                <VariableSizeList
                    itemData={itemData}
                    height={getHeight() + 2 * LISTBOX_PADDING}
                    width="100%"
                    ref={gridRef}
                    outerElementType={OuterElementType}
                    innerElementType="ul"
                    itemSize={(index) => getChildSize(itemData[index])}
                    overscanCount={5}
                    itemCount={itemCount}
                >
                    {renderRow}
                </VariableSizeList>
            </OuterElementContext.Provider>
        </div>
    );
});

ListboxComponent.propTypes = {
    children: T.node
};

const SelectedUsersField = (props) => {

    const {
        options = [],
        dropdownUsersOpen,
        onDropdownToggle,
        error,
        helperText,
        setValue,
        value = []
    } = props;

    const selectedUsers = internals.asArray(value);
    const availableOptions = internals.asArray(options);

    return (
        <Autocomplete
            className="fullWidth"
            multiple
            classes={{
                endAdornment: Classes.autocompleteEndAdornment,
                inputRoot: Classes.autocompleteInputRoot
            }}
            value={selectedUsers}
            onChange={(event, nextValue) => {

                setValue(internals.asArray(nextValue), event);
            }}
            options={availableOptions}
            filterOptions={internals.filterUserOptions}
            getOptionLabel={internals.getUserOptionLabel}
            isOptionEqualToValue={(option, optionValue) => {

                return option.id === optionValue.id;
            }}
            filterSelectedOptions
            disableCloseOnSelect
            disableListWrap
            ListboxComponent={ListboxComponent}
            renderTags={(tagValue, getTagProps) => {

                return <div style={{ background: '#ffffff' }}>
                    <Collapse timeout="auto" in={dropdownUsersOpen} unmountOnExit>
                        {tagValue.map((option, index) => {

                            return <UserChip key={option.id || index} {...getTagProps({ index })} user={option} />;
                        })}
                    </Collapse>
                </div>;
            }}
            renderInput={(args) => {

                return (<TextField
                    {...args}
                    variant="standard"
                    label={<div className={Classes.us} onClick={onDropdownToggle}>{`Selected Users (${selectedUsers.length})`} {dropdownUsersOpen ? <ExpandLess /> : <ExpandMore />}</div>}
                    id={'selected_users_input'}
                    placeholder='Start typing to search Users...'
                    error={!!error}
                    helperText={helperText}
                />);
            }}
        />
    );
};

SelectedUsersField.propTypes = {
    value: T.array,
    setValue: T.func,
    options: T.array,
    dropdownUsersOpen: T.bool,
    onDropdownToggle: T.func,
    error: T.object,
    helperText: T.string
};

const NotificationMessageField = (props) => {

    const {
        message,
        messageError,
        textCopied,
        onMessageChange
    } = props;

    const currentMessage = message || internals.buildEmptyMessage();
    const [editorState, setLocalEditorState] = useState(() => currentMessage.editorState || EditorState.createEmpty());
    const editorHtmlRef = useRef(currentMessage.text || '');
    const plainText = editorState.getCurrentContent().getPlainText();
    const editorClasses = [
        Classes.textEditor,
        (!currentMessage.text || currentMessage.text === '<p><br></p>') && Classes.textEditorPlaceholder
    ].filter((x) => !!x).join(' ');

    useEffect(() => {

        const nextMessageText = currentMessage.text || '';

        if (nextMessageText === editorHtmlRef.current) {
            return;
        }

        const nextEditorState = currentMessage.editorState
            || internals.buildMessageFromHtml(nextMessageText).editorState
            || EditorState.createEmpty();

        setLocalEditorState(nextEditorState);
        editorHtmlRef.current = nextMessageText;
    }, [currentMessage.editorState, currentMessage.text]);

    const setEditorState = (nextEditorState) => {

        const nextMessage = internals.buildMessageFromEditorState(nextEditorState);

        if (nextMessage.plainText.length <= NOTIFICATION_BLAST_LIMIT) {
            setLocalEditorState(nextEditorState);
            editorHtmlRef.current = nextMessage.text;
            onMessageChange?.(nextMessage);
        }
    };

    return (
        <div>
            <InputLabel>{`(${NOTIFICATION_BLAST_LIMIT} character limit - ${plainText.length}/${NOTIFICATION_BLAST_LIMIT})`}</InputLabel>
            <Editor
                placeholder='Type your notification here'
                toolbar={{
                    options: ['inline', 'emoji', 'blockType', 'list', 'link'],
                    inline: { options: ['bold', 'italic', 'underline', 'strikethrough'] },
                    blockType: { inDropdown: false, options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Code'] },
                    list: { options: ['unordered', 'ordered'], inDropdown: true },
                    link: {
                        showOpenOptionOnHover: false,
                        defaultTargetOption: '_blank',
                        inDropdown: false,
                        component: LinkToolbarComponent
                    }
                }}
                editorState={editorState}
                stripPastedStyles={false}
                wrapperClassName={Classes.textEditorWrapper}
                editorClassName={editorClasses}
                onEditorStateChange={setEditorState}
                handlePastedText={(text) => {

                    const contentState = editorState.getCurrentContent();
                    const blocksFromHTML = convertFromHTML(text);
                    const newContentState = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);
                    const newState = Modifier.replaceWithFragment(
                        contentState,
                        editorState.getSelection(),
                        newContentState.getBlockMap()
                    );

                    setEditorState(EditorState.push(editorState, newState, 'insert-fragment'));

                    return true;
                }}
            />
            {!!messageError && <Typography color={'error.main'}>{messageError}</Typography>}
            {textCopied ? <p>Notification saved to your clipboard. You may Paste above to resend.</p> : null}
        </div>
    );
};

NotificationMessageField.propTypes = {
    message: T.object,
    messageError: T.string,
    textCopied: T.bool,
    onMessageChange: T.func
};

module.exports = function BatchNotify(props) {

    const {
        fetchScheduledNotifications,
        deleteScheduledNotifications,
        scheduledNotifications,
        onSubmit,
        onSubmitTest,
        schoolId,
        currentUserId,
        schoolName,
        schoolRoles,
        activeSearchFilter,
        searchResults,
        interestsActiveFilter_notify,
        badges,
        interests,
        departments,
        officesList,
        yearsHiredList,
        isCompany,
        isCommunity,
        isSchoolOnline,
        onClickResetSearchFilters,
        majors
    } = props;

    const formId = 'batch-notify-form';
    const methodsRef = useRef(null);
    const selectedUsersSeedKeyRef = useRef(null);
    const [selectedRoleId, setSelectedRoleId] = useState('');
    const [nerpyAvailable, setNerpyAvailable] = useState(false);
    const [searchFilterOpen, setSearchFilterOpen] = useState(false);
    const [dropdownUsersOpen, setDropdownUsersOpen] = useState(true);
    const [textCopied, setTextCopied] = useState(false);
    const [message, setMessage] = useState(internals.buildEmptyMessage());
    const [messageError, setMessageError] = useState('');
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [notificationToDelete, setNotificationToDelete] = useState(null);
    const [copiedTextByNotificationId, setCopiedTextByNotificationId] = useState({});
    const { GlobalStyles, Wrapper } = internals;
    const searchResultsSeedKey = useMemo(() => {

        if (!searchResults) {
            return '';
        }

        return searchResults.map(({ id }) => id).join('|');
    }, [searchResults]);

    useEffect(() => {

        const listDropdownImg = document.querySelector('.rdw-dropdown-wrapper.rdw-list-dropdown .rdw-dropdown-selectedtext img');
        listDropdownImg?.setAttribute('alt', 'List dropdown');
        fetchScheduledNotifications();
    }, [fetchScheduledNotifications]);

    const copyText = async (text) => {

        if (text && text.length) {
            await Copy(text);
        }
    };

    const resetForm = () => {

        setSelectedRoleId('');
        setMessage(internals.buildEmptyMessage());
        setMessageError('');
        methodsRef.current?.reset(internals.buildDefaultValues());
    };

    const submitTest = async (values) => {

        const messageValidation = internals.validateMessage(message);

        if (messageValidation !== true) {
            setMessageError('Text is required!');
            return;
        }

        const startTime = internals.formatStartTime(values.startTime);

        onSubmitTest({
            text: message.text,
            emojiSymbol: values.emojiSymbol,
            schoolId,
            userId: currentUserId,
            usePushSystem: values.usePushSystem,
            startTime
        }, () => null);

        await copyText(message.text);
        setTextCopied(true);
    };

    const submitValues = async (values) => {

        if (values.selectedRoleId === 'test-notify' && !values.sendViaNerpy) {
            await submitTest(values);
            return;
        }

        const messageValidation = internals.validateMessage(message);

        if (messageValidation !== true) {
            setMessageError('Text is required!');
            return;
        }

        const payload = {
            sendViaNerpy: nerpyAvailable && values.sendViaNerpy === true,
            csv: values.csv || null,
            text: message.text,
            roleId: (['csv', 'search', 'test-notify'].includes(values.selectedRoleId)) ? null : values.selectedRoleId,
            selectedUsers: values.selectedRoleId === 'test-notify' ? [currentUserId] : values.selectedRoleId === 'search' ? (values.selectedUsers || []).map(({ id }) => id) : null,
            excludedUserIds: values.selectedRoleId === 'search'
                ? BatchNotifyFormConfig.buildExcludedUserIds(searchResults, values.selectedUsers)
                : null,
            usedCriteria: values.selectedRoleId === 'search' ? {
                ...activeSearchFilter,
                selectedRole: activeSearchFilter.contextFilter,
                contextFilter: null
            } : null,
            emojiSymbol: values.emojiSymbol,
            usePushSystem: values.usePushSystem,
            startTime: internals.formatStartTime(values.startTime)
        };

        onSubmit({ ...payload, schoolId }, () => null);

        await copyText(message.text);
        resetForm();
        setTextCopied(true);
    };

    const renderActiveFilters = () => {

        return internals.renderActiveFilters({
            activeSearchFilter,
            badges,
            departments,
            interestsActiveFilter_notify,
            isCommunity,
            isCompany,
            isSchoolOnline,
            majors,
            officesList,
            onCancel: () => {

                onClickResetSearchFilters();
                setSelectedRoleId('');
                methodsRef.current?.setValue('selectedRoleId', '', { shouldDirty: true, shouldValidate: true });
            },
            onEdit: () => setSearchFilterOpen(true),
            schoolRoleGroups: props.schoolRoleGroups,
            selectedRoleId,
            yearsHiredList
        });
    };

    const handleMessageChange = (nextMessage) => {

        setMessage(nextMessage);
        setMessageError('');
        setTextCopied(false);
    };

    const formConfig = useMemo(() => BatchNotifyFormConfig.buildFormConfig({
        NotificationMessageField,
        nerpyAvailable,
        SelectedUsersField,
        dropdownUsersOpen,
        formId,
        onDropdownToggle: () => setDropdownUsersOpen((open) => !open),
        onRoleChange: (nextRoleId) => {

            setSelectedRoleId(nextRoleId);

            if (nextRoleId === 'search') {
                setSearchFilterOpen(true);
            }
        },
        onStartTimeOpen: () => {

            const methods = methodsRef.current;
            const currentStartTime = methods?.getValues('startTime');

            if (!currentStartTime) {
                const now = Dayjs();
                const minutes = now.minute();
                const minutesToAdd = 10 - (minutes % 10);
                methods?.setValue('startTime', now.add(minutesToAdd, 'minute'), {
                    shouldDirty: true,
                    shouldValidate: true
                });
            }
        },
        onSubmit: submitValues,
        renderNotificationMessage: () => (
            <NotificationMessageField
                message={message}
                messageError={messageError}
                textCopied={textCopied}
                onMessageChange={handleMessageChange}
            />
        ),
        renderActiveFilters,
        schoolName,
        schoolRoles,
        searchResults,
        selectedRoleId,
        textCopied,
        validateCsv: internals.validateCsv
    }), [
        nerpyAvailable,
        dropdownUsersOpen,
        formId,
        message,
        messageError,
        renderActiveFilters,
        schoolName,
        schoolRoles,
        searchResults,
        selectedRoleId,
        submitValues,
        textCopied
    ]);

    const {
        methods,
        Form
    } = useForm(formConfig);

    methodsRef.current = methods;

    useEffect(() => {

        if (selectedRoleId !== 'search') {
            selectedUsersSeedKeyRef.current = null;
            return;
        }

        if (searchResults === null || selectedUsersSeedKeyRef.current === searchResultsSeedKey) {
            return;
        }

        selectedUsersSeedKeyRef.current = searchResultsSeedKey;
        methodsRef.current?.setValue('selectedUsers', searchResults || [], { shouldDirty: false, shouldValidate: true });
    }, [searchResults, searchResultsSeedKey, selectedRoleId]);

    const handleDeleteClick = (notification) => {

        setDeleteDialogOpen(true);
        setNotificationToDelete(notification);
    };

    const handleDeleteDialogClose = () => {

        setDeleteDialogOpen(false);
        setNotificationToDelete(null);
    };

    const handleDeleteConfirm = () => {

        if (notificationToDelete) {
            deleteScheduledNotifications({ notificationId: notificationToDelete.id });
        }

        setDeleteDialogOpen(false);
        setNotificationToDelete(null);
    };

    const handleCopyScheduledContent = (notification, field) => {

        switch (field) {
            case 'text': {
                const copiedMessage = internals.buildMessageFromHtml(notification.text);
                setMessage(copiedMessage);
                setMessageError('');
                setTextCopied(false);
                setCopiedTextByNotificationId((copied) => ({
                    ...copied,
                    [notification.id]: true
                }));

                setTimeout(() => {

                    setCopiedTextByNotificationId((copied) => ({
                        ...copied,
                        [notification.id]: false
                    }));
                }, 2000);
                break;
            }

            case 'time': {
                const scheduledTime = Dayjs(notification.scheduledTime);
                if (scheduledTime.isValid() && scheduledTime.isAfter(Dayjs())) {
                    methods.setValue('startTime', scheduledTime, { shouldDirty: true, shouldValidate: true });
                }

                break;
            }

            default:
                return;
        }
    };

    return (
        <BottomButtonContainer
            btnLabel='Send Notification'
            formId={formId}
            onBtnClick={methods.handleSubmit(submitValues)}
        >
            <GlobalStyles />
            <NerpyTriviaAdmin key={`trivia:${schoolId}:${currentUserId}`} schoolId={schoolId} currentUserId={currentUserId} />
            <NerpyOutreachAdmin key={`${schoolId}:${currentUserId}`} schoolId={schoolId} currentUserId={currentUserId} onAvailability={setNerpyAvailable} />
            {internals.renderScheduledNotifications({
                copiedTextByNotificationId,
                handleCopyScheduledContent,
                handleDeleteClick,
                scheduledNotifications,
                schoolRoles,
                interests
            })}
            <h2>Send Notification</h2>
            <Wrapper>
                {Form}
            </Wrapper>
            <NotifyUsersFilterDialog
                open={searchFilterOpen}
                onRequestClose={() => setSearchFilterOpen(false)}
            />
            <Dialog
                open={deleteDialogOpen}
                onClose={handleDeleteDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Confirm Delete
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this notification? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteDialogClose}>Cancel</Button>
                    <Button onClick={handleDeleteConfirm} color="error" autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </BottomButtonContainer>
    );
};

module.exports.propTypes = {
    fetchScheduledNotifications: T.func.isRequired,
    deleteScheduledNotifications: T.func.isRequired,
    scheduledNotifications: T.array,
    onSubmit: T.func.isRequired,
    onSubmitTest: T.func.isRequired,
    schoolId: T.number.isRequired,
    currentUserId: T.number.isRequired,
    schoolName: T.string.isRequired,
    schoolRoles: T.array.isRequired,
    schoolRoleGroups: T.array.isRequired,
    activeSearchFilter: T.object,
    searchResults: T.array,
    interestsActiveFilter_notify: T.array,
    badges: T.array,
    interests: T.array,
    departments: T.array,
    officesList: T.arrayOf(
        T.shape({
            id: T.number,
            name: T.string
        })
    ),
    yearsHiredList: T.arrayOf(
        T.shape({
            id: T.number,
            year: T.number
        })
    ),
    isCompany: T.bool,
    isCommunity: T.bool,
    isSchoolOnline: T.bool,
    onClickResetSearchFilters: T.func,
    majors: T.arrayOf(T.shape({
        id: T.number,
        name: T.string
    }))
};

internals.buildEmptyMessage = () => ({
    text: '',
    plainText: '',
    editorState: EditorState.createEmpty()
});

internals.buildDefaultValues = () => ({
    sendViaNerpy: false,
    emojiSymbol: '',
    selectedRoleId: '',
    csv: null,
    selectedUsers: [],
    usePushSystem: true,
    startTime: null,
    message: internals.buildEmptyMessage()
});

internals.buildMessageFromEditorState = (editorState) => {

    const options = {
        entityStyleFn: (entity) => {

            const entityType = entity.get('type').toLowerCase();
            if (entityType === 'link') {
                const data = entity.getData();

                let safeUrl = data.url.replace('http://', 'https://');
                if (!data.url.startsWith('http://') && !data.url.startsWith('https://')) {
                    safeUrl = `https://${safeUrl}`;
                }

                return {
                    element: 'a',
                    attributes: {
                        href: safeUrl,
                        target: data.targetOption
                    }
                };
            }
        }
    };

    const text = stateToHTML(editorState.getCurrentContent(), options);
    const plainText = editorState.getCurrentContent().getPlainText();

    return {
        text,
        plainText,
        editorState
    };
};

internals.buildMessageFromHtml = (html) => {

    const blocksFromHTML = convertFromHTML(html);
    const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
    );
    const editorState = EditorState.createWithContent(contentState);

    return {
        text: html,
        plainText: contentState.getPlainText(),
        editorState
    };
};

internals.formatStartTime = (startTime) => {

    if (startTime && Dayjs.isDayjs(startTime)) {
        return startTime.toISOString();
    }

    return null;
};

internals.validateCsv = (value) => {

    if (!value) {
        return 'File must be a csv';
    }

    const match = value.name.match(/\.csv$/);
    if (match === null) {
        return 'File must be a csv';
    }

    if (value.size > (4.9 * MB_IN_BYTES)) {
        return 'csv must be under 5mb';
    }

    return true;
};

internals.validateMessage = (value) => {

    if (!value || !value.plainText || !value.plainText.length) {
        return 'Text is required!';
    }

    return true;
};

internals.renderScheduledNotifications = ({
    copiedTextByNotificationId,
    handleCopyScheduledContent,
    handleDeleteClick,
    scheduledNotifications,
    schoolRoles,
    interests
}) => {

    const formatUsedCriteria = (criteria) => {

        const formattedCriteria = [];
        const ignoredFields = [
            'openSocial',
            'customLocation',
            'locationType',
            'radius',
            'isBasicSearch',
            'contextFilterType',
            'sortType',
            'contextFilter',
            'useMatchScoring'
        ];

        Object.entries(criteria).forEach(([key, value]) => {

            if (value === null || ignoredFields.includes(key)) {
                return;
            }

            const formattedKey = key
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, (str) => str.toUpperCase());

            let formattedValue = value;
            if (typeof value === 'boolean') {
                formattedValue = value ? 'Yes' : 'No';
            }
            else if (Array.isArray(value)) {
                if (key === 'interests') {
                    formattedValue = value
                        .map((id) => {

                            const interest = interests.find((i) => i.id === id);
                            return interest ? interest.name : id;
                        })
                        .join(', ');
                }
                else {
                    formattedValue = value.join(', ');
                }
            }

            formattedCriteria.push(`${formattedKey}: ${formattedValue}`);
        });

        return formattedCriteria;
    };

    if (!scheduledNotifications || scheduledNotifications.length === 0) {
        return null;
    }

    const getRoleName = (roleId) => {

        if (roleId === 'all') {
            return 'All Users';
        }

        if (roleId === 'search') {
            return 'Search-based';
        }

        const role = schoolRoles.find(({ id }) => id === roleId);
        return role ? role.label : `Role ID: ${roleId}`;
    };

    return (
        <div className={Classes.scheduledNotificationsContainer}>
            <div className={Classes.scheduledNotificationsHeader}>
                <h2>Scheduled Notifications</h2>
            </div>
            <div className={Classes.scheduledNotificationsList}>
                {scheduledNotifications.map((notification, index) => (
                    <Paper
                        key={index}
                        elevation={1}
                        className={Classes.notificationItem}
                    >
                        <div>
                            {notification.emojiSymbol && (
                                <Typography className={Classes.emoji}>
                                    {notification.emojiSymbol}
                                </Typography>
                            )}
                        </div>
                        <div className={Classes.notificationTime}>
                            <div className={Classes.timeWithCopy}>
                                <Typography variant="subtitle2">
                                    Scheduled for: {Dayjs(notification.scheduledTime).format('MMM D, YYYY h:mm A')} ({Dayjs.tz.guess()})
                                </Typography>
                                <Button
                                    size="small"
                                    onClick={() => handleCopyScheduledContent(notification, 'time')}
                                    className={Classes.copyButton}
                                >
                                    COPY TIME TO BELOW
                                </Button>
                            </div>
                        </div>
                        <Typography variant="body2" className={Classes.notificationRole}>
                            {notification.usedCriteria ? (
                                <div>
                                    <p>Used Criteria:</p>
                                    <ul>
                                        {formatUsedCriteria(notification.usedCriteria).map((criteria, idx) => (
                                            <li key={idx}>{criteria}</li>
                                        ))}
                                    </ul>
                                </div>
                            ) : notification.roleId ? (
                                `Role to Notify: ${getRoleName(notification.roleId)}`
                            ) : (
                                'Test: Notify me'
                            )}
                        </Typography>
                        <div className={Classes.notificationContent}>
                            <div
                                className={Classes.notificationText}
                                dangerouslySetInnerHTML={{ __html: notification.text }}
                            />
                            <Button
                                size="small"
                                onClick={() => handleCopyScheduledContent(notification, 'text')}
                                className={Classes.copyButton}
                            >
                                {copiedTextByNotificationId[notification.id] ? 'Copied!' : 'COPY TEXT TO BELOW'}
                            </Button>
                        </div>
                        <div className={Classes.deleteButtonContainer}>
                            <Button
                                color="error"
                                onClick={() => handleDeleteClick(notification)}
                                className={Classes.deleteButton}
                            >
                                DELETE
                            </Button>
                        </div>
                    </Paper>
                ))}
            </div>
        </div>
    );
};

internals.renderActiveFilters = ({
    activeSearchFilter,
    badges,
    departments,
    interestsActiveFilter_notify,
    isCommunity,
    isCompany,
    isSchoolOnline,
    majors,
    officesList,
    onCancel,
    onEdit,
    schoolRoleGroups,
    selectedRoleId,
    yearsHiredList
}) => {

    const isFilteringResults = activeSearchFilter && !(Object.keys(activeSearchFilter).length === 0) && !activeSearchFilter.allByMatches;

    let interestTitle = null;

    if (interestsActiveFilter_notify.length) {
        if (interestsActiveFilter_notify.length === 1) {
            interestTitle = interestsActiveFilter_notify[0].name;
        }
        else {
            interestTitle = 'Multiple Interests Chosen';
        }
    }

    let selectedBadge = null;
    if (activeSearchFilter && activeSearchFilter.badge) {
        const badgeItem = badges.find(({ name }) => name === activeSearchFilter.badge);
        if (badgeItem) {
            selectedBadge = badgeItem.label;
        }
    }

    let roleText = null;
    if (activeSearchFilter && activeSearchFilter.contextFilter) {
        const activeRoleGroup = schoolRoleGroups.find((roleGroup) => roleGroup.name === activeSearchFilter.contextFilter) || null;
        roleText = activeRoleGroup ? activeRoleGroup.label : '';
    }

    let timeStatusText = null;
    if (activeSearchFilter && activeSearchFilter.fullTimeStatus) {
        timeStatusText = _capitalize(activeSearchFilter.fullTimeStatus);
    }

    const getBooleanFilterText = (value) => {

        if (value === true || value === 'true') {
            return 'Yes';
        }

        if (value === false || value === 'false') {
            return 'No';
        }

        return null;
    };

    const isTransferText = getBooleanFilterText(activeSearchFilter?.isTransfer);
    const isOnlineText = getBooleanFilterText(activeSearchFilter?.isOnline);
    const veteranText = getBooleanFilterText(activeSearchFilter?.isVeteran);
    const searchIsParentText = getBooleanFilterText(activeSearchFilter?.searchIsParent);

    let departmentText = null;
    if (activeSearchFilter && activeSearchFilter.departmentId) {
        const selectedDepartment = departments.find((item) => item.id === activeSearchFilter.departmentId);
        if (selectedDepartment) {
            departmentText = selectedDepartment.name;
        }
    }

    const workRemoteText = getBooleanFilterText(activeSearchFilter?.workRemote);

    let yearHiredText = null;
    if (activeSearchFilter && activeSearchFilter.yearHiredId) {
        const selectedYear = yearsHiredList.find((item) => item.id === activeSearchFilter.yearHiredId);
        if (selectedYear) {
            yearHiredText = selectedYear.year;
        }
    }

    let officeText = null;
    if (activeSearchFilter && activeSearchFilter.officeId) {
        const selectedOffice = officesList.find((item) => item.id === activeSearchFilter.officeId);
        if (selectedOffice) {
            officeText = selectedOffice.name;
        }
    }

    if (isFilteringResults || selectedRoleId === 'search') {
        let firstMajor = activeSearchFilter.major ? activeSearchFilter.major[0] : null;

        if (firstMajor) {
            firstMajor = majors.find(({ id }) => id === firstMajor)?.name;
        }

        const activeFilters = [
            {
                label: 'User Type',
                value: roleText
            }, {
                label: 'Name',
                value: activeSearchFilter.name ? activeSearchFilter.name : null
            }, {
                label: 'Age',
                value: activeSearchFilter.age ? activeSearchFilter.age : null
            }, {
                label: 'Career',
                value: activeSearchFilter.career ? activeSearchFilter.career : null
            }, {
                label: 'Profession',
                value: activeSearchFilter.profession ? activeSearchFilter.profession : null
            }, {
                label: 'Bio',
                value: activeSearchFilter.bio ? activeSearchFilter.bio : null
            }, {
                label: 'Department',
                value: departmentText
            }, {
                label: isCompany ? 'Affiliated Office' : 'Campus',
                value: officeText
            }, {
                label: 'Year Hired',
                value: yearHiredText
            }, {
                label: 'Work Remote',
                value: workRemoteText
            }, {
                label: 'Title',
                value: activeSearchFilter.title ? activeSearchFilter.title : null
            }, {
                label: 'Badge',
                value: selectedBadge
            }, {
                label: 'Transfer Student',
                value: isTransferText
            }, {
                label: 'Online Student',
                value: isOnlineText
            }, {
                label: 'Veteran',
                value: veteranText
            }, {
                label: 'Parent',
                value: searchIsParentText
            }, {
                label: 'Full / Part-time',
                value: timeStatusText
            }, {
                label: 'Incoming Class',
                value: activeSearchFilter.incomingClass ? activeSearchFilter.incomingClass : null
            }, {
                label: 'Graduating Class',
                value: activeSearchFilter.graduatingClass ? activeSearchFilter.graduatingClass : null
            }, {
                label: 'Major',
                value: firstMajor || null
            }, {
                label: 'Student Name',
                value: activeSearchFilter.studentName ? activeSearchFilter.studentName : null
            }, {
                label: 'Interests',
                value: interestTitle
            }
        ];

        return (
            <ActiveFilterSearchBar
                activeFilters={activeFilters}
                isFilteringResults={isFilteringResults}
                onOpenFilters={onEdit}
                onClearFilters={onCancel}
                placeholder='Search by interests, majors...'
                showClearButton
            />
        );
    }

    return null;
};

internals.Wrapper = Styled.div`
    width: 100%;
`;

internals.GlobalStyles = createGlobalStyle`
    .MuiMultiSectionDigitalClock-root {
        /* Target the popper clock content globally */
        .MuiMultiSectionDigitalClockSection-root {
            &::after {
                height: 0;
            }

            .Mui-disabled {
                display: none; /* Hide disabled times */
            }
        }
    }
`;
